import './index.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GeckoField, GECKO_CONSTS } from 'ui';
import BotTagManagerOption from '../Option';
import BotTagManagerService from '../Service';
import { renderError } from 'services/gecko-error';
import { tagOptionsSelector } from 'reducers/bot_tags_selector';

export class BotTagManagerField extends Component {
  inputRef = null;

  state = {
    value: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.item.bot_tag_ids || [],
    };
  }

  linkFn(valueAdded) {
    return BotTagManagerService.http
      .link(this.props.item, valueAdded)
      .then(() => {
        // Update redux store
        BotTagManagerService.dispatch.add(this.props.item, valueAdded);
      })
      .catch(renderError);
  }

  unlinkFn(valueRemoved) {
    return BotTagManagerService.http
      .unlink(this.props.item, valueRemoved)
      .then(() => {
        // Update redux store
        BotTagManagerService.dispatch.remove(this.props.item, valueRemoved);
      })
      .catch(renderError);
  }

  handleChange(_key, newValue) {
    if (Array.isArray(newValue)) {
      const valueAdded = newValue.find(
        (newValueItem) => !this.state.value.includes(newValueItem)
      );
      const valueRemoved = this.state.value.find(
        (newValueItem) => !newValue.includes(newValueItem)
      );

      if (
        !this.props.controlled &&
        this.props.item.id &&
        this.props.item.id !== 'new'
      ) {
        if (!!valueAdded) this.linkFn(valueAdded);
        if (!!valueRemoved) this.unlinkFn(valueRemoved);
      }

      this.props.onChange(newValue);

      const value = newValue;
      this.setState({ value });
    }

    // Clear input
    this.inputRef.select.setState({ inputValue: '' });
  }

  handleCreate(data) {
    if (!data.value) return;

    return BotTagManagerService.http
      .create(this.props.item.bot_id, data.value)
      .then((tag) => {
        // Update redux store
        BotTagManagerService.dispatch.newTag(tag);

        // Update value
        this.handleChange(null, this.state.value.concat([tag.id]));
      })
      .catch(renderError);
  }

  // Overrides isOptionUnique method on react-select-plus to allow for case-insensitive checking
  isBotTagOptionUnique = ({ option, options, labelKey, valueKey }) => {
    if (!options || !options.length) {
      return true;
    }
    return !options.some(
      (existingOption) =>
        existingOption[labelKey].toLowerCase().trim() ===
          option[labelKey].toLowerCase().trim() ||
        existingOption[valueKey].toLowerCase().trim() ===
          option[valueKey].toLowerCase().trim()
    );
  };
  prepareField() {
    return {
      key: 'value',
      type: GECKO_CONSTS.FIELD_TYPE_SELECT_CREATE_MULTI,
      options: this.props.tagOptions,
      config: Object.assign(
        {
          id: this.props.id,
          optionComponent: BotTagManagerOption,
          ref: (element) => {
            this.inputRef = element;
          },
          onOpen: () => {
            BotTagManagerService.keepDropdownOpen = false;
          },
          onClose: (event) => {
            if (BotTagManagerService.keepDropdownOpen) {
              this.inputRef.select.setState({ isOpen: true });
            }
          },
          isOptionUnique: this.isBotTagOptionUnique,
          closeOnSelect: false,
          removeSelected: true,
          autoFocus: false,
          clearable: false,
          placeholder: 'Type to search or create a tag',
          onNewOptionClick: this.handleCreate.bind(this),
        },
        this.props.config
      ),
    };
  }

  render() {
    return (
      <div className="BotTagManagerField">
        <GeckoField
          field={this.prepareField()}
          values={{ value: this.state.value }}
          handler={this.handleChange.bind(this)}
        />
      </div>
    );
  }
}

BotTagManagerField.defaultProps = {
  item: {},
  config: {},
  onChange: () => {},
  controlled: true, // !controlled will update the db and redux
};

const mapStateToProps = (state) => {
  return {
    tagOptions: tagOptionsSelector(state),
  };
};

export default connect(mapStateToProps)(BotTagManagerField);
